const actions = {
    STOCK_BALANCE_READ_REQUEST: 'STOCK_BALANCE_READ_REQUEST',
    STOCK_BALANCE_READ_SUCCESS: 'STOCK_BALANCE_READ_SUCCESS',
    STOCK_BALANCE_READ_ERROR: 'STOCK_BALANCE_READ_ERROR',

    readStockBalance: productId => ({
        type: actions.STOCK_BALANCE_READ_REQUEST,
        productId,
    }),
};
export default actions;
